module.exports = __webpack_public_path__ + "img/icon-minus.4bf2d53f.svg";